import React, { useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { format } from 'date-fns';
import api from '../../services/api';

const estilos = {
    fundo: {
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
    },
    card: {
        width: 'min(440px, 92vw)', maxHeight: '80vh', background: '#fff', borderRadius: 12,
        boxShadow: '0 20px 50px rgba(0,0,0,0.3)', overflow: 'hidden', display: 'flex',
        flexDirection: 'column', fontFamily: 'inherit',
    },
    topo: {
        display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px',
        background: '#fff7ed', borderBottom: '1px solid #fed7aa',
    },
    icone: {
        width: 30, height: 30, borderRadius: '50%', background: '#f97316', color: '#fff',
        display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0,
    },
    titulo: { margin: 0, fontSize: 14, fontWeight: 700, color: '#9a3412' },
    sub: { margin: 0, fontSize: 12, color: '#7c2d12' },
    lista: { overflowY: 'auto', padding: '6px 16px' },
    linha: {
        display: 'grid', gridTemplateColumns: '78px 1fr auto', gap: 10, alignItems: 'center',
        padding: '7px 0', borderBottom: '1px solid #f1f5f9', fontSize: 12.5, color: '#1e293b',
    },
    tipo: { fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    valor: { fontWeight: 700, color: '#0f766e' },
    rodape: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '10px 16px', borderTop: '1px solid #e2e8f0', background: '#f8fafc',
    },
    botao: {
        border: 'none', background: '#f97316', color: '#fff', padding: '6px 18px',
        borderRadius: 8, fontWeight: 600, cursor: 'pointer',
    },
};

const moeda = (v) => (parseFloat(v) || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });

const dataBR = (d) => {
    const dt = d ? new Date(d) : null;
    return dt && !isNaN(dt) ? format(dt, 'dd/MM/yyyy') : '-';
};

export const LIMITE_AVISO_EVENTOS = 3;

const estaNaRotaCotacao = () => window.location.pathname.replace(/\/+$/, '') === '/cotacao';

// Consulta os eventos da placa e devolve o modal pronto para renderizar quando houver 3+ eventos
export function useAvisoEventos() {
    const [aviso, setAviso] = useState(null);

    const verificarPlaca = useCallback(async (placa) => {
        if (estaNaRotaCotacao()) return;

        const p = String(placa || '').trim().toUpperCase();
        if (p.length < 7) return;
        try {
            const res = await api.get(`/evento/placa/${p}`);
            const validos = (Array.isArray(res.data) ? res.data : []).filter(e => e.status !== 'E');
            if (validos.length >= LIMITE_AVISO_EVENTOS && !estaNaRotaCotacao()) {
                setAviso({ placa: p, eventos: validos });
            }
        } catch (error) {
            // aviso é complementar: falha na consulta não deve bloquear a pesquisa
        }
    }, []);

    const modalAviso = aviso && !estaNaRotaCotacao()
        ? <ModalAvisoEventos placa={aviso.placa} eventos={aviso.eventos} onClose={() => setAviso(null)} />
        : null;

    return { verificarPlaca, modalAviso };
}

export function ModalAvisoEventos({ placa, eventos = [], onClose }) {
    const total = eventos.reduce((s, e) => s + (parseFloat(e.orcamento) || 0), 0);

    // Portal evita o corte por ancestrais com transform/overflow (ex.: ModalFlutuante)
    return createPortal(
        <div style={estilos.fundo} onClick={onClose}>
            <div style={estilos.card} onClick={(e) => e.stopPropagation()}>
                <div style={estilos.topo}>
                    <div style={estilos.icone}>!</div>
                    <div>
                        <p style={estilos.titulo}>Atenção: {eventos.length} eventos cadastrados</p>
                        <p style={estilos.sub}>O veículo {String(placa || '').toUpperCase()} já teve {LIMITE_AVISO_EVENTOS} ou mais eventos.</p>
                    </div>
                </div>

                <div style={estilos.lista}>
                    {eventos.map((e, i) => (
                        <div key={e._id || i} style={estilos.linha}>
                            <span>{dataBR(e.dataEvento)}</span>
                            <span style={estilos.tipo} title={e.tipoEvento}>{e.tipoEvento || '-'}</span>
                            <span style={estilos.valor}>{moeda(e.orcamento)}</span>
                        </div>
                    ))}
                </div>

                <div style={estilos.rodape}>
                    <span style={{ fontSize: 12, color: '#475569' }}>Total: <b>{moeda(total)}</b></span>
                    <button style={estilos.botao} onClick={onClose}>OK</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
